"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeHighlightProvider = exports.useHighlightCreatedNode = exports.useNodeHighlightContext = void 0;
const react_1 = __importStar(require("react"));
const NodeHighlightContext = (0, react_1.createContext)(null);
const useNodeHighlightContext = () => {
    const context = (0, react_1.useContext)(NodeHighlightContext);
    if (!context) {
        throw new Error('useNodeHighlightContext must be used within NodeHighlightProvider');
    }
    return context;
};
exports.useNodeHighlightContext = useNodeHighlightContext;
const useHighlightCreatedNode = () => {
    const [highlightedNodeId, setHighlightedNodeId] = (0, react_1.useState)(null);
    const highlightNode = (0, react_1.useCallback)((nodeId) => {
        setHighlightedNodeId(nodeId);
        setTimeout(() => {
            const element = document.querySelector(`[data-node-id="${nodeId}"]`);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest',
                });
            }
        }, 150);
    }, []);
    const clearHighlight = (0, react_1.useCallback)(() => {
        setHighlightedNodeId(null);
    }, []);
    (0, react_1.useEffect)(() => () => setHighlightedNodeId(null), []);
    return {
        highlightedNodeId,
        highlightNode,
        clearHighlight,
    };
};
exports.useHighlightCreatedNode = useHighlightCreatedNode;
const NodeHighlightProvider = ({ children }) => {
    const highlightState = (0, exports.useHighlightCreatedNode)();
    return (react_1.default.createElement(NodeHighlightContext.Provider, { value: highlightState }, children));
};
exports.NodeHighlightProvider = NodeHighlightProvider;
